import { colors, Divider, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthGuard, ErrorMessage, GenericHeader, LoadingIndicator, Page, RenderGuard, RoutineList } from "components";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Module } from "services";
import { ModelsActions } from "store/actions";
import { curriculum_manager } from 'utils/constants';
import useErrorCatcher from "utils/useErrorCatcher";
import useRouter from 'utils/useRouter';
import { Summary } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

let mounted = false;

const ModuleDetail = props => {
  const { match, history } = props;
  const classes = useStyles();
  const { module_id, tab } = match.params;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const model = useSelector(state => state.models.module);
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    setLoading(true);
    runAsyncBlock(async () => {
      const { model } = await Module.detail(module_id);
      dispatch(ModelsActions.update_model({ module: model }));
    }).finally(() => setLoading(false));

    // eslint-disable-next-line
  }, [module_id]);

  useEffect(() => {
    mounted = true;
    return () => {
      mounted = false;
    }
  }, []);

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  const tabs = [
    { value: "summary", label: "Summary" },
    { value: "routines", label: "Routines" },
  ];

  if (!tab) {
    return <Redirect to={`/modules/${module_id}/summary`} />;
  }

  if (!tabs.find(t => t.value === tab)) {
    return <Redirect to="/errors/error-404" />;
  }

  const handleDelete = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      await Module.del(module_id);
      router.history.push('/modules');
    }).finally(() => mounted && setLoading(false));
  }

  return (
    <AuthGuard roles={[curriculum_manager]} projects={[]}>
      <Page className={classes.root} title="Module Details" >
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator variant="card" active={loading} />
        <RenderGuard renderIf={!loading && model}>
          {model && <GenericHeader subheader={model.name_en} header="Module" subtitle={model.code} />}
          <Tabs
            className={classes.tabs}
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={tab}
            variant="scrollable" >
            {tabs.map(tab => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
          </Tabs>
          <Divider className={classes.divider} />
          <div className={classes.content}>
            {tab === "summary" && <Summary handleDelete={handleDelete} />}
            {tab === "routines" && model && <RoutineList mmodule={model} />}
          </div>
        </RenderGuard>
      </Page>
    </AuthGuard>
  );
};

ModuleDetail.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default ModuleDetail;
